<mat-chip class="rp-chip" disableRipple="true" [removable]="isRemovable()" [disabled]="isDisabled()" (removed)="remove()">
  {{ label() }}
  @if (isRemovable()) {
    <rp-icon matChipRemove iconName="remove" />
  }
</mat-chip>
